import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Hero } from '../components/Hero';
import { useEffect } from 'react';
import { Form } from '../components/Form';

import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

export const WishFor2026 = ({hibisId, scAnswer}) => {

  useEffect(() => {
    const idMap = {
      a: 'id_nl_interes_1',
      b: 'id_nl_interes_2',
      c: 'id_nl_interes_3',
      d: 'id_nl_interes_4',
      e: 'id_nl_interes_5',
      f: 'id_nl_interes_6'
    };

    const normalized = scAnswer?.toLowerCase();
    if (!normalized || !idMap[normalized]) return;

    let retries = 0;
    const maxRetries = 10;

    const tryCheck = () => {
      const el = document.getElementById(idMap[normalized]);
      if (el) {
        el.checked = true;
      } else if (retries < maxRetries) {
        retries++;
        setTimeout(tryCheck, 300);
      } else {
        console.warn('Checkbox not found after max retries');
      }
    };

    tryCheck();
  }, [scAnswer]);

  return (
    <>
      <Header />
      <Hero image="Addiko-wish-for-2026.jpg" xPos="63%" yPos="28%" />
      <div className="addiko-app">
        <Container>
            <Row>
                <Col md={6} className="p-3">
                    <h1>Katero željo želite uresničiti v letu 2026?</h1>
                    <p className="text-left">
                      Novo leto je idealen čas, da si izberete nekaj, kar si resnično želite uresničiti. Morda si želite malo več svobode pri mesečnih stroških, lepši dom, zanesljiv avto, novo opremo za hobi ali pa končno poskrbeti zase.
                    </p>
                    <p className="text-left">
                      Z Addiko hitrim kreditom si lahko ta korak omogočite hitreje — preprosto in na način, ki vam ustreza. Izberite, kaj vam trenutno največ pomeni, in pomagali vam bomo preveriti možnosti, ki so za vas najbolj primerne.
                    </p>
                    <p className="text-left">
                      Obrestna mera je fiksna, kar pomeni, da točno veste, kakšen bo vaš obrok skozi celotno obdobje financiranja. Naš svetovalec vas lahko pokliče, odgovori na vprašanja in vam pomaga najti rešitev, ki najbolje podpira vaše letošnje želje.
                    </p>
                    <p className="text-left">
                      <b>Izpolnite obrazec, označite svojo željo in poslali vam bomo prilagojene informacije glede na vaš izbor.</b>
                    </p>
                    <p className="text-left">
                      Zdaj je pravi čas, da sebe postavite na prvo mesto — in začnete leto tako, kot si ga želite.
                    </p>
                    <p className="text-left">
                        Kjerkoli in kadarkoli, vedno z vami!<br />
                        Addiko banka
                    </p>
                </Col>
                <Col md={1} className="p-3 d-none d-md-block">
                    &nbsp;
                </Col>
                <Col md={5} className="p-3">
                  <Form guid="0e92121d-b218-4d22-b2f3-1dd105c1119b" hibisId={hibisId} />
                </Col>
            </Row>
        </Container>
      </div>      
      <Footer />
    </>
  );
}